import { useMutation } from 'react-query';

import { getMFACode as mutationFn } from 'api/endPoints/getMFACode';

export const useMutationGetMFACode = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    email: string;
}
